import GreetingsPage from './GreetingsPage';

const GreetingsConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  routes: [
    {
      path: 'greetings',
      element: <GreetingsPage />,
    },
  ],
};

export default GreetingsConfig;
